import React from "react";
import "../Component/Component.css/VillageDevelopmentSection.css";

// images import
import imgGramSabha from "../Images/imgGramSabha.png";
import imgSwachhta from "../Images/imgSwachhta.png";
import imgMahila from "../Images/imgMahila.png";
import imgSamvad from "../Images/imgSamvad.png";

const VillageDevelopmentSection = () => {
  return (
    <div className="vds-container">
      <h2 className="vds-title">गाव विकासासाठी कार्यक्रम</h2>
      <p className="vds-subtitle">
        स्वच्छ ग्राम अभियान – स्वच्छता, कचरा व्यवस्थापन आणि हिरित उपक्रम.
      </p>

      <div className="vds-grid">
        {/* कार्ड 1 */}
        <div className="vds-card">
          <img src={imgSamvad} className="vds-image" alt="Gram Sabha" />

          <div className="vds-overlay">
            <h3 className="vds-card-title">ग्रामसभेची चालू सत्र</h3>
            <ul className="vds-list">
              <li>गावातील विविध विकासकामांचे नियोजन</li>
              <li>शासकीय योजनांची अंमलबजावणी</li>
              <li>नागरिकांच्या सूचना व तक्रारींची नोंद</li>
              <li>प्रशासन आणि लोकसहभागावर भर</li>
            </ul>
          </div>
        </div>

        {/* कार्ड 2 */}
        <div className="vds-card">
          <img src={imgSwachhta} className="vds-image" alt="Cleanliness" />

          <div className="vds-overlay">
            <h3 className="vds-card-title">स्वच्छता मोहिम</h3>
            <ul className="vds-list">
              <li>घराघरातील कचऱ्याचे वर्गीकरण</li>
              <li>सार्वजनिक ठिकाणांची साफसफाई</li>
              <li>प्लास्टिक मुक्त गाव अभियान राबविणे</li>
              <li>स्वच्छतेबाबत जनजागृती करणे</li>
            </ul>
          </div>
        </div>

        {/* कार्ड 3 */}
        <div className="vds-card">
          <img src={imgMahila} className="vds-image" alt="Mahila Group" />

          <div className="vds-overlay">
            <h3 className="vds-card-title">महिला बचत गट उपक्रम</h3>
            <ul className="vds-list">
              <li>स्वयंरोजगार आणि लघुउद्योगांना प्रोत्साहन.</li>
              <li>नियमित बचतीद्वारे आर्थिक स्थैर्य वाढविणे.</li>
              <li>विविध प्रशिक्षणांद्वारे कौशल्यवृद्धी.</li>
              <li>समाजातील महिला नेतृत्व विकास.</li>
            </ul>
          </div>
        </div>

        {/* कार्ड 4 */}
        <div className="vds-card">
          <img
            src={imgGramSabha}
            className="vds-image"
            alt="Citizens Meeting"
          />

          <div className="vds-overlay">
            <h3 className="vds-card-title">नागरिकांशी संवाद</h3>
            <ul className="vds-list">
              <li>थेट संवाद साधला जातो</li>
              <li>निर्णय प्रक्रियेत सहभाग</li>
              <li>ऑनलाइन तक्रार सुविधा</li>
              <li>प्रशासनातील पारदर्शकता</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VillageDevelopmentSection;
